"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarIcon;
var _react = _interopRequireDefault(require("react"));
var _calendarMonthOutline = _interopRequireDefault(require("./calendar-month-outline"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function CalendarIcon(props) {
  return (0, _core.jsx)(_calendarMonthOutline.default, props);
}